import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UploadInternalPartnerTaskFileService } from "./upload-internal-partner-task-file.service";
import { RemoveInternalPartnerTaskFileService } from "./remove-internal-partner-task-file.service";

@NgModule({
  imports: [CommonModule],
  providers: [
    UploadInternalPartnerTaskFileService,
    RemoveInternalPartnerTaskFileService,
  ],
})
export class TasksInternalPartnerFileModule {}
